import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { EditableText as T } from "@/components/live/EditableText";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    explore: [
      { name: "About", path: "/about" },
      { name: "Gallery", path: "/gallery" },
      { name: "Blog", path: "/blog" },
      { name: "Q&A", path: "/faq" },
    ],
    connect: [
      { name: "Booking Etiquette", path: "/booking-etiquette" },
      { name: "Submit Inquiry", path: "/booking" },
      { name: "Tour Schedule", path: "/tour" },
      { name: "Contact", path: "/contact" },
    ],
    extras: [
      { name: "Travel", path: "/travel" },
      { name: "Spoil Me", path: "/gifts" },
      { name: "Links", path: "/links" },
    ],
  };

  return (
    <footer className="bg-charcoal text-ivory" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <T k="footer.kalani-luana" className="font-accent text-3xl text-champagne-gold">Kalani Luana</T>
            </Link>
            <T k="footer.luxury-companion-based" as="p" className="font-body text-sm text-ivory/70 leading-relaxed mb-6">Luxury companion based in New York/New Jersey with availability in Los Angeles and worldwide.</T>
            <p className="font-body text-xs text-ivory/50">
              All content © {currentYear} Kalani Luana
            </p>
          </div>

          {/* Explore Links */}
          <div>
            <T k="footer.explore" as="h4" className="font-body text-sm tracking-widest uppercase text-champagne-gold mb-6">Explore</T>
            <ul className="space-y-3">
              {footerLinks.explore.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-ivory/70 hover:text-champagne-gold transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Links */}
          <div>
            <T k="footer.connect" as="h4" className="font-body text-sm tracking-widest uppercase text-champagne-gold mb-6">Connect</T>
            <ul className="space-y-3">
              {footerLinks.connect.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-ivory/70 hover:text-champagne-gold transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Extras Links */}
          <div>
            <T k="footer.extras" as="h4" className="font-body text-sm tracking-widest uppercase text-champagne-gold mb-6">Extras</T>
            <ul className="space-y-3">
              {footerLinks.extras.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-ivory/70 hover:text-champagne-gold transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-ivory/50 flex items-center gap-1">
              Made with <Heart className="w-3 h-3 text-lipstick-red" /> 
            </p>
            
            <T k="footer.18-only-all" as="p" className="font-body text-xs text-ivory/50 text-center">18+ Only | All arrangements are between consenting adults | Donations are for time and companionship</T>

            <div className="flex items-center gap-4">
              <Link to="/admin/login" className="font-body text-xs text-ivory/30 hover:text-ivory/50 transition-colors">
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
